import ServiceBase from './ServiceBase';

export default class InvoicesService extends ServiceBase {
    bulkPrintInvoices(params, projectID) {
        return this.$http.post('Invoices/BulkPrintInvoices', { ...params, projectID });
    }

    bulkUpdateInvoiceStates(model) {
        return this.$http.post('Invoices/bulkUpdateInvoiceStates', model);
    }

    correctPrepaymentInvoicesByUnshippedAmount(projectID, correctionReason, forcedIssueDate, filters) {
        const model = {
            ...filters, projectID, correctionReason, forcedIssueDate,
        };
        return this.$http.post('Invoices/correctPrepaymentInvoicesByUnshippedAmount', model);
    }

    forceTotalCorrectionOfInvoices(projectID, params, correctionReason, forcedIssueDate) {
        const model = {
            ...params, projectID, correctionReason, forcedIssueDate,
        };
        return this.$http.post('Invoices/forceTotalCorrectionOfInvoices', model);
    }

    getInvoiceIDsFromFile(sourceFile, projectID) {
        const formData = new FormData();
        formData.append('sourceFile', sourceFile);
        formData.append('projectID', projectID);

        return this.$http.post('Invoices/getInvoiceIDsFromFile', formData);
    }

    getImportInvoiceNumbersExampleFile() {
        return this.$http.get('Invoices/getImportInvoiceNumbersExampleFile', { responseType: 'blob' });
    }

    regenerateInvoices(params, projectID) {
        return this.$http.post('Invoices/RegenerateInvoices', { ...params, projectID });
    }

    exportInvoices(filters, creatorID, projectID, exportType, options) {
        const params = {
            ...filters,
            projectID,
            creatorID,
            exportType,
            options,
        };
        return this.$http.post('Invoices/ExportInvoices', params);
    }

    getInvoiceIDs(filters, creatorID, projectID) {
        const params = {
            invoiceNumber: null,
            orderPublicID: null,
            minIssueDate: null,
            maxIssueDate: null,
            minCreateDate: null,
            maxCreateDate: null,
            invoiceState: null,
            invoiceType: null,
            creatorID,
            projectID,
            ...filters,
        };

        return this.$http.post('Invoices/GetInvoiceIDs', params);
    }

    generateInvoices(model) {
        return this.$http.post('Invoices/GenerateInvoices', model);
    }

    generateOrderInvoices(model) {
        return this.$http.post('Invoices/GenerateOrderInvoices', model);
    }

    generateCorrectionInvoices(request) {
        return this.$http.post('Invoices/generateCorrectionInvoices', request);
    }

    printInvoice(invoiceID, projectID) {
        return this.$http.get('Invoices/PrintInvoice', { params: { invoiceID, projectID }, responseType: 'blob' });
    }

    searchInvoices(filters, creatorID, projectID, pageSize, pageIndex) {
        const params = {
            invoiceNumber: null,
            orderPublicID: null,
            minIssueDate: null,
            maxIssueDate: null,
            minCreateDate: null,
            maxCreateDate: null,
            invoiceState: null,
            invoiceType: null,
            creatorID,
            projectID,
            pageSize,
            pageIndex,
            ...filters,
        };

        return this.$http.post('Invoices/SearchInvoices', params);
    }

    getInvoiceExportTypes(projectID, creatorID) {
        return this.$http.get('Invoices/GetInvoiceExportTypes', { params: { projectID, creatorID } });
    }

    getInvoice(invoiceID, creatorID, projectID) {
        return this.$http.get('Invoices/getInvoice', { params: { invoiceID, creatorID, projectID } });
    }

    getInvoiceGeneratorTypes(projectID) {
        return this.$http.get('Invoices/GetInvoiceGeneratorTypes', { params: { projectID } });
    }
}
